import type { Model } from '@patsnap/tahiti-core/common/model';
import type { CustomHighlight } from '../types';

export const CustomHighlightModel = Symbol.for('CustomHighlightModel');

export interface CustomHighlightModel extends Model<CustomHighlight> {}
